// assets/bench-pp.js
// Delegated click handling for resolution/preset chips + section refresh.
(function () {
  // Click handler stays attached even when sections re-render.
  document.addEventListener('click', function (evt) {
    const btn = evt.target.closest('.bench-chip');
    if (!btn) return;

    const attrKey = btn.getAttribute('data-attr');       // "chosen_res" or "chosen_preset"
    const attrVal = btn.getAttribute('data-value');      // "1080p", "1440p", "low", "medium", "high"
    if (!attrKey || !attrVal) return;

    // Find the nearest section wrapper to refresh after update.
    const sectionEl = btn.closest('[data-section-id]');
    const sectionId = sectionEl ? sectionEl.getAttribute('data-section-id') : null;

    // Optimistic UI: toggle active class immediately
    const group = btn.parentElement; // .bench-controls__group
    if (group) {
      group.querySelectorAll('.bench-chip.is-active').forEach(el => el.classList.remove('is-active'));
      btn.classList.add('is-active');
    }

    // Update cart attributes only (preserves other attributes)
    // Shopify Ajax Cart: POST /cart/update.js with { attributes: { ... } }
    // Reference: https://shopify.dev/docs/api/ajax/reference/cart#update-cart-attributes
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [attrKey]: attrVal } })
    })
      .then(r => r.json())
      .then(() => {
        // Fire theme-wide event in case other code listens
        document.dispatchEvent(new CustomEvent('uncapped:cart-updated', { bubbles: true }));

        // Refresh just this section via Section Rendering API
        if (!sectionId) return;
        const url = window.location.pathname + '?sections=' + encodeURIComponent(sectionId) + '&t=' + Date.now();
        return fetch(url, { credentials: 'same-origin' })
          .then(r => r.json())
          .then(json => {
            if (!json || !json[sectionId]) return;
            const html = json[sectionId];
            const wrap = document.createElement('div');
            wrap.innerHTML = html;
            const next = wrap.querySelector('[data-section-id="' + sectionId + '"]');
            if (next && sectionEl) sectionEl.replaceWith(next);
          });
      })
      .catch(() => { /* swallow to avoid UI noise */ });
  }, { passive: true });
})();
